import { TableRow } from '@tymbe/components/table';
import { ComponentProps } from 'react';

export const TyTableRow = (props: ComponentProps<typeof TableRow>) => (
  <TableRow {...props} />
);
